import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireEditorOrAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false, requireEditorOrAdmin = false }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user && !user.is_superuser) {
    return <Navigate to="/companies" replace />;
  }

  if (requireEditorOrAdmin && user && user.role === 'viewer') {
    return <Navigate to="/companies" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
